<div class="grid flex header-gap">
  <div class="col-12">
    <div class="page-header mb-6 gap-0">
      <h1 class="orders">{{ 'Order.OurTests' | translate }}</h1>
      <div class="yellow-underline"></div>
    </div>
  </div>
  <div class="col-12 md:col-10 md:col-offset-1">
    @if (newOrderState(); as state) {
      @if (state.productStatus === eActionStatus.Success) {
        <p-tabs class="new-order" [value]="0">
          @if (products$ | async; as productList) {
            <p-tablist>
              <p-tab value="-1" style="width: 15%" class="bg-black-alpha-10 p-2" (click)="onBackClicked()">
                <h4 class="w-full inline-flex justify-content-center align-items-center">
                  <i class="pi pi-arrow-left"></i>
                  <span class="ml-2">{{ 'Order.Back' | translate }}</span>
                </h4>
              </p-tab>
              @for (product of productList; track product; let i = $index) {
                @if (product.isActive) {
                  <p-tab [value]="i" [style]="{width: 70 / productList.length + '%'}">
                    <div
                      data-testid="veracityPart"
                      class="veracity-part"
                      [class.search-variant-highlight]="highlightProduct">
                      <h4 class="veracity-text">
                        {{ product.name }}
                      </h4>
                    </div>
                  </p-tab>
                }
              }
            </p-tablist>
            <p-tabpanels>
              @for (product of productList; track product; let i = $index) {
                @if (product.isActive) {
                  <p-tabpanel [value]="i" class="pt-0">
                    <div class="col-12 md:col-8 md:col-offset-2">
                      <span class="large-paragraph block text-justify" [innerHTML]="product.description"> </span>
                      <app-product-variant
                        [productAttributes]="product.productWithAttributes"
                        [productID]="product.id"
                        [variantID]="variantId"
                        (highlightProduct)="onHighlightProduct($event)" />
                    </div>
                  </p-tabpanel>
                } @else {
                  <div class="p-2">
                    <p-message severity="info" [closable]="false">
                      <div class="content-box">
                        <span class="summary-txt">Info</span>
                        <span> {{ 'Order.InactiveProduct' | translate }}</span>
                      </div>
                    </p-message>
                  </div>
                }
              }
            </p-tabpanels>
          }
        </p-tabs>
      }
      @if (state.productStatus === eActionStatus.Error || state.productStatus === eActionStatus.Failure) {
        @if (!(products$ | async)?.length) {
          <div class="p-2">
            <p-message severity="info" [closable]="false" icon="pi pi-info-circle">
              <div class="content-box">
                <span class="summary-txt">Info</span>
                <span> {{ 'Order.FailedToLoadProduct' | translate }}</span>
              </div>
            </p-message>
          </div>
        }
      }
      @if (state.productStatus === eActionStatus.Initial || state.productStatus === eActionStatus.Pending) {
        <div class="grid">
          <div class="flex flex-auto justify-content-center my-2">
            <ng-container
              *ngTemplateOutlet="
                loadingTemplate;
                context: {
                  config: {
                    count: 1,
                    width: '70vw',
                    height: '5rem',
                    inline: true,
                  },
                }
              " />
          </div>
          <div class="flex flex-auto justify-content-center my-2">
            <ng-container
              *ngTemplateOutlet="
                loadingTemplate;
                context: {
                  config: {
                    count: 5,
                    width: '40vw',
                    height: '5rem',
                    inline: false,
                  },
                }
              " />
          </div>
        </div>
      }
    }
  </div>
</div>

<ng-template #loadingTemplate let-config="config">
  <div [class.flex]="config.inline">
    @for (n of getNumberArray(config.count); track n) {
      <div
        class="p-2"
        [class.inline-flex]="config.inline"
        [class.w-full]="!config.inline"
        [class.flex]="!config.inline">
        <p-skeleton [width]="config.width" [height]="config.height" class="overflow-hidden" />
      </div>
    }
  </div>
</ng-template>
